import * as tslib_1 from "tslib";
import React from 'react';
import { logger } from './BiLogger.logger';
import { BiLoggerContextConsumer, BiLoggerContextProvider, } from './BiLogger.context';
import { MouseButton, getClickType } from '../utils/clickHelpers';
var BiLogger = /** @class */ (function (_super) {
    tslib_1.__extends(BiLogger, _super);
    function BiLogger() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.contextValue = {
            setTrackingRef: function (DOMnode) { return (_this.childNode = DOMnode); },
        };
        _this.eventHandler = function (e) {
            if (!e.isTrusted ||
                ![MouseButton.Main, MouseButton.Auxiliary].includes(getClickType(e))) {
                return true;
            }
            var _a = _this.props, eventType = _a.eventType, eventData = _a.eventData, publicSession = _a.publicSession;
            var biData = _this.transformBiEventData(eventData);
            var wait = logger.log(publicSession, biData);
            // data was sent via beacon, no need to hold anything
            if (logger.isBeacon()) {
                return;
            }
            // no bacon - cancel event, wait for logging to finish, then re-fire
            if (_this.isPureEvent(e) && !e.defaultPrevented) {
                e.preventDefault();
                if (eventType === 'click') {
                    _this.preventClick();
                }
                var target_1 = e.target;
                wait.then(function () {
                    if (eventData.href) {
                        window.location.href = eventData.href;
                    }
                    else if (target_1 && _this.isLinkClicked(e)) {
                        target_1.dispatchEvent(new MouseEvent(eventType, {
                            bubbles: true,
                            cancelable: true,
                        }));
                    }
                });
            }
        };
        return _this;
    }
    BiLogger.prototype.render = function () {
        var _this = this;
        var children = this.props.children;
        return (React.createElement(BiLoggerContextConsumer, null, function (biContext) {
            _this.biContext = biContext;
            return (React.createElement(BiLoggerContextProvider, { value: _this.contextValue }, children));
        }));
    };
    BiLogger.prototype.componentDidMount = function () {
        if (this.childNode) {
            var eventName = this.getEventName();
            // add handler on capture, 3th param true, to catch events even if children use stopPropagation
            this.childNode.addEventListener(eventName, this.eventHandler, true);
        }
        else if (process.env.NODE_ENV !== 'production') {
            throw new Error('BiLogger childNode ref has not setted up');
        }
    };
    BiLogger.prototype.componentWillUnmount = function () {
        if (this.childNode) {
            var eventName = this.getEventName();
            this.childNode.removeEventListener(eventName, this.eventHandler, true);
        }
    };
    BiLogger.prototype.transformBiEventData = function (eventData) {
        var mergedData = tslib_1.__assign({}, this.biContext, eventData);
        // tslint-disable-next-line no-unused-variable
        var _rankIndex = mergedData._rankIndex, _rankOffset = mergedData._rankOffset, href = mergedData.href, biData = tslib_1.__rest(mergedData, ["_rankIndex", "_rankOffset", "href"]);
        if (typeof _rankOffset !== 'undefined' &&
            typeof _rankIndex !== 'undefined') {
            biData.rank = _rankOffset + _rankIndex;
        }
        return biData;
    };
    // prevent click from some events that can't do it directly, for example mousedown
    BiLogger.prototype.preventClick = function () {
        var _this = this;
        if (!this.childNode) {
            return;
        }
        var handler = function (e) {
            e.preventDefault();
            _this.childNode.removeEventListener('click', handler);
        };
        this.childNode.addEventListener('click', handler);
    };
    BiLogger.prototype.getEventName = function () {
        var eventType = this.props.eventType;
        switch (eventType) {
            case 'click':
                return 'mousedown'; // mousedown to be able handle mouse middle click
            default: {
                if (process.env.NODE_ENV !== 'production') {
                    throw new Error('undefined eventType');
                }
            }
        }
    };
    // check that event was happened without additional meta data/keyboard buttons
    BiLogger.prototype.isPureEvent = function (e) {
        if (e.metaKey || e.ctrlKey || e.altKey || e.shiftKey || e.which !== 1) {
            return false;
        }
        return true;
    };
    // check if link was clicked
    BiLogger.prototype.isLinkClicked = function (e) {
        var target = e.target;
        if (target &&
            (target.tagName.toLowerCase() === 'a' || target.closest('a'))) {
            return true;
        }
        return false;
    };
    return BiLogger;
}(React.Component));
export default BiLogger;
//# sourceMappingURL=BiLogger.js.map